import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import PlacementTestRulerForm from './PlacementTestRulerForm';
import PlacementTestRulerFormService from '../services/PlacementTestRulerFormService';

class PlacementTestRulerFormContainer extends Component {

  static propTypes = {
    placementTestRulerId: PropTypes.string,
  };

  static defaultProps = {
    placementTestRulerId: null,
  };

  PlacementTestRulerFormService = new PlacementTestRulerFormService();
  componentWillMount() {
    this.PlacementTestRulerFormService.handleLoad(this.props.placementTestRulerId);
  }

  render() {
    return (
      <PlacementTestRulerForm
        onSubmit={this.PlacementTestRulerFormService.handleSubmit}
        onChange={this.PlacementTestRulerFormService.form.setValue}
        onReset={this.PlacementTestRulerFormService.form.reset}
        values={this.PlacementTestRulerFormService.form.getValues()}
        errors={this.PlacementTestRulerFormService.form.errors}
        submitting={this.PlacementTestRulerFormService.submit.fetching}
        isDirty={this.PlacementTestRulerFormService.form.isDirty}
      />
    );
  }
}

export default observer(PlacementTestRulerFormContainer);
